import { render, staticRenderFns } from "./DowloadCatalogLegacy.vue?vue&type=template&id=68aac208&"
import script from "./DowloadCatalogLegacy.vue?vue&type=script&lang=js&"
export * from "./DowloadCatalogLegacy.vue?vue&type=script&lang=js&"
import style0 from "./DowloadCatalogLegacy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports